import React, { useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2FormRangeInput from '../../..//Form/V2FormRangeInput/V2FormRangeInput';
import V2FilterFooter from './V2FilterFooter';
import { useMethods } from '@lhb/hook';
import { isEqual, isNotEmpty, isNotEmptyAny } from '@lhb/func';
const V2FilterRangeInput: React.FC<any> = ({
  name,
  headFilter,
  setHeadFilter,
  cacheHeadFilter,
  close,
  comType,
  extra,
  comProps,
}) => {
  const [targetValue, setTargetValue] = useState<any>(headFilter[name] || []);
  const methods = useMethods({
    confirm(newValue, force = false) {
      close();
      if (force) {
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      } else if (!isEqual(headFilter[name], newValue)) {
        if (!isNotEmpty(newValue) && !isNotEmpty(headFilter[name])) {
          return;
        }
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      }
    },
    handleSearch() {
      methods.confirm(targetValue);
    },
    clearFiltersAndClose() {
      if (isNotEmptyAny(targetValue?.value)) {
        methods.confirm(undefined, true);
      } else {
        methods.confirm(undefined);
      }
      setTargetValue(undefined);
    },
    onChange(v) {
      const newValue = {
        comType,
        value: v,
        extra
      };
      setTargetValue(newValue);
      cacheHeadFilter.current = {
        ...cacheHeadFilter.current,
        [name]: newValue
      };
    }
  });
  return (
    <div className={cs([styles.V2TableFilterCommon])}>
      <div>
        <V2FormRangeInput
          noStyle
          name={[`${name}-min`, `${name}-max`]}
          minConfig={{
            defaultValue: targetValue?.value?.[0],
            onChange(v) {
              methods.onChange([v, targetValue?.value?.[1]]);
            },
            onPressEnter: methods.handleSearch,
          }}
          originAnt
          maxConfig={{
            defaultValue: targetValue?.value?.[1],
            onChange(v) {
              methods.onChange([targetValue?.value?.[0], v]);
            },
            onPressEnter: methods.handleSearch,
          }}
          {...comProps}
        />
      </div>
      <V2FilterFooter
        handleSearch={methods.handleSearch}
        clearFiltersAndClose={methods.clearFiltersAndClose}
      />
    </div>
  );
};

export default V2FilterRangeInput;
